import BezierCurve from './BezierCurve';

export default BezierCurve;
